<template>
    <div class="distributing">
        <div class="evaluation">
            配电概况
        </div>
        <div class="land">
            <div class="item">
                <div class="tt">合闸数量</div>
                <div class="num" style="color:#0D94FF">
                    {{infoData.highBreaker.switchOff+infoData.lowBreaker.switchOff}}
                </div>
            </div>
            <div class="item">
                <div class="tt">断路器总数</div>
                <div class="num">
                    {{infoData.highBreaker.powerCount+infoData.lowBreaker.powerCount}}
                </div>
            </div>
        </div>
        <div class="evaluation">
            用电排行
            <div class="tag">
                <label :class="{ active: range == 'day' }" @click="range = 'day'">日</label>
                <label :class="{ active: range == 'month' }" @click="range = 'month'">月</label>
                <label :class="{ active: range == 'year' }" @click="range = 'year'">年</label>
            </div>
        </div>
        <div class="Ranking">
            <p v-for="(item,index) in ranglist"><span>{{index+1}}.{{item.loopName}} </span><i>{{item.sum.toFixed(2)}}kWh</i></p>
        </div>
    </div>
</template>
<script>
import {
    eymOverview,
    eymitemEnergyConsumption,
    eymPowerSort
} from '../../api/power.js'
import {
	dayStart,
	dayEnd,
	monthStart,
	yearStart,
	monthEnd,
	yearEnd,
	monthDays,
	currentDay,
	dateFormat
} from "../../util/DateUtil";
export default {
    data() {
        return {
            infoData:{},
            ranglist:[],
            range:"day"
        }
    },
    computed:{
        projectId() {
            return this.$store.getters.projectId
        }
    },
    watch:{
        range(){
            this.getRankList();
        },
        '$store.getters.areaId'() {
            this.initData();
            this.getRankList();
        },
    },
    mounted(){
        this.initData();
        this.getRankList();
    },
    methods:{
        async initData(){
            let obj = {
                areaId:this.$store.getters.areaId,
                projectId:this.projectId
            }
            let response = await eymOverview(obj);
            this.infoData = response.data.data.result || {};  
        },
        async getRankList(){
            let start
			let end
            let date = new Date();
            switch (this.range) {
				case "day":
					start = dayStart(date)
					end = dayEnd(date)
					break
				case "month":
					start = monthStart(date)
					end = monthEnd(date)
					break
				case "year":
					start = yearStart(date)
					end = yearEnd(date)
					break

			}
            let obj = {
                areaId:this.$store.getters.areaId,
                projectId:this.projectId,
                end:end,
                start:start
            }
            let response = await eymPowerSort(obj);
            this.ranglist = response.data.data.list || {};  
        }
    }
}
</script>
<style scoped lang="less">
.distributing {
    .evaluation {
        height: 3.2vh;
        padding-top: 7rem;
        padding-left: 13rem;
        line-height: 28rem;
        box-sizing: border-box;
        font-size: 16rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        position: relative;
        border-bottom: 1px solid #ddd;

        &::before {
            content: '';
            width: 5rem;
            height: 18rem;
            background: #0D94FF;
            position: absolute;
            left: 0;
            top: 12.5rem;
        }

        .tag {
            float: right;
            position: relative;
            label {
                color: #333;
                cursor: pointer;
                margin-left: 12px;
                position: relative;
            }

            .active {
                color: #0E9CFF;
            }

            .active::before {
                content: "";
                border-top: 2px solid #0E9CFF;
                position: absolute;
                top: -12rem;
                width: 100%;
            }
        }


    }

    .Ranking {
        padding: 16px 16px;
        max-height: 300px;
        overflow: auto;
        width: 100%;
        font-size: 16px;
        p {
            line-height: 36px;
            span{
                display: inline-block;
                width: 75%;
            }
        }
    }

    .land {
        display: flex;
        padding: 15rem 20rem;
        min-height: 52rem;
        align-items: flex-start;

        .item {
            font-size: 16rem;
            width: 50%;

            .num {
                font-size: 30rem;
                font-weight: bold;
                margin-top: 5rem;
            }

            .name {
                color: #666666;
            }

        }
    }
}</style>